import { render, staticRenderFns } from "./PublishStatistics.vue?vue&type=template&id=5d1a9a84&scoped=true"
import script from "./PublishStatistics.vue?vue&type=script&lang=js"
export * from "./PublishStatistics.vue?vue&type=script&lang=js"
import style0 from "./PublishStatistics.vue?vue&type=style&index=0&id=5d1a9a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1a9a84",
  null
  
)

export default component.exports